var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "cd-container" },
    [
      _c(
        "b-row",
        { attrs: { "d-flex": "", "flex-column": "" } },
        _vm._l(_vm.makers, function(maker) {
          return _c(
            "b-col",
            {
              key: maker.id,
              staticClass: "cd-entry makers p-2",
              attrs: { cols: "6", sm: "6", md: "4", lg: "3", xl: "3" },
              on: {
                click: function($event) {
                  return _vm.selectMaker(maker)
                }
              }
            },
            [
              _c("Box", { staticClass: "bottom-text cd-maker maker-image" }, [
                _c("div", { class: _vm.makerImage(maker) }),
                _c("p", [_vm._v(" " + _vm._s(maker.label) + " ")])
              ])
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }